export default "__VITE_PUBLIC_ASSET__b524fe3c__"